import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { configureContractManager } from './web3';

configureContractManager(
  "0xc8734e3b9b1c33a8faff018bff4b8d498cd57cb5",
  "0x7d32512edc62f442b8d75aff696b815885e48218",
  "0x514ef1c6ccac1367ef8c26eab38ce633cd49a838",
  '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619',
  'matic',
  'a5704bb4e73f4ffa8ff7a1fa5999c0d1'
)

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
